export default __webpack_public_path__ + "static/law2x-0627dc94841f858b6d5c57d3e5725faa.png";